import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {ManagedAccountsSearchCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountPrimaryManager} from 'src/openapi/admin/models/AccountPrimaryManager';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {GetManagedAccountIdsRequestFilters} from 'src/openapi/admin/models/GetManagedAccountIdsRequestFilters';


export const accountSearchResultPrimaryManagerSlice = getCachedTableDataSlice<
    Record<string, AccountPrimaryManager>,
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
>('assignedAccountsSearchResultPrimaryManager');

export const accountSearchResultPrimaryManagerActions = accountSearchResultPrimaryManagerSlice.actions;

const accountSearchResultPrimaryManagerCacheSelector: CachedTableCacheSelector<Record<string, AccountPrimaryManager>>
    = state => state.userPage.tabs.assignedAccounts.primaryManager.cache;
export const accountSearchResultPrimaryManagerDataSelector: CachedTableDataSelector<
    Record<string, AccountPrimaryManager>
> = state => state.userPage.tabs.assignedAccounts.primaryManager;
export const accountSearchResultPrimaryManagerResultSelector = getCachedTableResultSelector(
    accountSearchResultPrimaryManagerCacheSelector,
    accountSearchResultStateSelector,
);
